<div *ngIf="updateAvailable">
  <button mat-flat-button
          #btn
          (click)="reload()"
          matTooltip="New version available! Press to reload page!"
          color="primary">Update available!
  </button>
</div>
